var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutOfStockinline = function SvgOutOfStockinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AF3535",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.162 17.996a7.838 7.838 0 1 0 0-15.676 7.838 7.838 0 0 0 0 15.676M4.621 4.617 15.704 15.7"
  })));
};
export default SvgOutOfStockinline;